/* Dansk katalog for locale-no.js (del 2 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'fi.recheck': 'Jeg har bekræftet',
  'fi.stillUnverified': 'Adressen er stadig ikke bekræftet. Tjek indbakken og spam.',
  'fi.decline': 'Afvis',
  'fi.declined': 'Invitationen er afvist.',
  'set.firm.title': 'Regnskabsbureau',
  'set.firm.sub': 'Bureauet får først adgang til regnskabet, når du accepterer, og mister den, i det øjeblik du afslutter samarbejdet.',
  'set.firm.none': 'Ingen regnskabsbureauer har adgang til denne virksomhed, og ingen har bedt om det.',
  'set.firm.pending': 'Venter på dit svar',
  'set.firm.active': 'Har adgang',
  'set.firm.end': 'Afslut samarbejdet',
  'set.firm.endConfirm': 'Afslut samarbejdet med {firm}? Medarbejderne mister adgangen til regnskabet med det samme.',
  'set.firm.ended': 'Samarbejdet er afsluttet, og adgangen er trukket tilbage.',
  'set.firm.onlyManagers': 'Kun ejer og administrator kan svare på en anmodning.',
  'rf.create.title': 'Opret regnskabsbureau',
  'rf.create.eyebrow': 'Regnskabsbureau',
  'rf.create.readyBody': 'Bureauet er oprettet, og du er ejer. Næste trin er at invitere dine medarbejdere og tilknytte klienter.',
  'rf.create.openSurface': 'Åbn bureauvisningen',
  'rf.create.body': 'Bureauet hentes fra Enhetsregisteret. Du bliver ejer og kan invitere medarbejdere bagefter.',
  'rf.create.orgNumber': 'Organisationsnummer',
  'rf.create.hintDigits': 'Ni cifre. Bureauet skal være registreret i Enhetsregisteret.',
  'rf.create.hintReady': 'Nummeret hentes fra Enhetsregisteret, når du opretter.',
  'rf.create.hintDemo': 'Demokontoen kan bruge et opdigtet nummer. Giv bureauet et navn nedenfor.',
  'rf.create.firmName': 'Bureauets navn',
  'rf.create.nameRequired': 'Kunne ikke finde virksomheden i Enhetsregisteret. Skriv bureauets navn for at fortsætte.',
  'rf.create.unverifiedNote': 'Bureauet oprettes uden registeropslag og markeres som ikke-verificeret. Det skal verificeres, før rigtige bureauer tages i brug.',
  'rf.create.demoNote': 'Demokontoen angiver selv navnet. Almindelige konti får navnet fra Enhetsregisteret.',
  'rf.create.submit': 'Opret bureau',
  'rf.create.working': 'Opretter …',
  'rf.create.done': 'Regnskabsbureauet er oprettet',
  'rf.create.note': 'Opslaget bekræfter, at virksomheden findes. Det kontrollerer ikke, om du kan handle på dens vegne.',
  'rf.member.title': 'Stilling',
  'rf.member.email': 'E-mail',
  'rf.member.person': 'Person',
  'rf.member.rights': 'Rettigheder',
  'rf.member.inviteTitle': 'Invitér en medarbejder',
  'rf.member.invite': 'Send invitation',
  'rf.member.inviting': 'Sender …',
  'rf.member.invited': 'Invitation sendt',
  'rf.member.inviteMailFailed': 'Invitationen er oprettet, men e-mailen kunne ikke sendes.',
  'rf.member.listTitle': 'Medarbejdere',
  'rf.member.none': 'Ingen medarbejdere endnu.',
  'rf.member.updated': 'Stillingen er ændret',
  'rf.member.remove': 'Fjern adgang',
  'rf.member.removed': 'Adgangen er fjernet',
  'rf.member.removedWithClients': 'Adgangen er fjernet, også hos {count} klienter.',
  'rf.member.removeConfirm': 'Fjern adgangen for {name}? Al klientadgang, som bureauet har givet denne person, trækkes tilbage samtidig.',
  'rf.member.removeNote': 'Når du fjerner en medarbejder, trækkes også al klientadgang, som bureauet har givet personen, tilbage — hos alle klienter, i én handling.',
  'rf.member.ownerRights': 'Ejer af bureauet',
  'rf.member.canControl': 'Kan kontrollere',
  'rf.nav.backToApp': 'Til mit regnskab',
  'rf.nav.back': 'Tilbage',
  'app.nobusiness.openFirm': 'Åbn regnskabsbureauet',
  'rf.tab.close': 'Luk fane',
  'rf.tab.assignFirst': 'Ingen er sat på opgaven for denne klient endnu. Adgangen til regnskabet følger tildelingen — sæt nogen på opgaven under Klienter.',
  'rf.tab.assignNeeded': 'Du er ikke sat på opgaven for denne klient. Bed en administrator i bureauet om at sætte dig på den.',
  'rf.soon.clients': 'Klientoversigten kobles nu til den klientstatus, som backend beregner for hver klient.',
  'rf.soon.reconciliation': 'Afstemningsvisningen bygges nu. Adgangsmodellen og klientstatussen, den bygger på, er på plads.',
  'rf.soon.control': 'Kontrolvisningen kommer efter afstemning. Fire-øjne-princippet håndhæves i backend, når den lanceres.',
  'rf.noFirm.title': 'Du er ikke medlem af et regnskabsbureau',
  'rf.noFirm.body': 'Du er ikke medlem af et bureau endnu. Opret dit eget nedenfor, eller bed en administrator i bureauet om at invitere dig — invitationen kommer på e-mail.',
  'tc.title': 'Teamchat',
  'tc.rooms': 'Rum',
  'tc.dms': 'Direkte beskeder',
  'tc.newRoom': 'Nyt rum',
  'tc.roomName': 'Rumnavn',
  'tc.roomNamePlaceholder': 'F.eks. Kontrolteamet',
  'tc.createRoom': 'Opret rum',
  'tc.noColleagues': 'Ingen andre i bureauet endnu',
  'tc.commonRoom': 'Fællesrum',
  'tc.room': 'Rum',
  'tc.commonSubtitle': 'Fælles rum for hele teamet',
  'tc.roomSubtitle': 'Rum i bureauet',
  'tc.dm': 'Direkte besked',
  'tc.dmSubtitle': 'Direkte besked',
  'tc.empty': 'Ingen beskeder her endnu — skriv den første.',
  'tc.placeholder': 'Skriv en besked…',
  'tc.send': 'Send',
  'tc.unknown': 'Ukendt',
  'shell.client.clients': 'Dine klienter',
  'shell.client.signOutSub': 'Afslut sessionen på denne enhed',
  'shell.client.signOutFailed': 'Kunne ikke logge ud. Prøv igen.',
  'shell.client.none': 'Ingen virksomheder',
  'shell.client.noBusinesses': 'Ingen virksomheder',
  'shell.client.connecting': 'Opretter forbindelse til Plumme backend',
  'shell.client.personalEconomy': 'Privatøkonomi',
  'shell.client.accountingClient': 'Regnskabsklient',
  'shell.client.org': 'Org. {org}',
  'shell.suggest.invoices': 'Fakturaer',
  'shell.suggest.customers': 'Kunder',
  'shell.suggest.vouchers': 'Bilag',
  'trial.title': 'Prøveperioden er aktiv',
  'trial.active': 'Prøveperioden er aktiv.',
  'trial.dayLeft': 'Du har {days} dag tilbage.',
  'trial.daysLeft': 'Du har {days} dage tilbage.',
  'trial.body': 'Alt virker - hyg dig med at lære Plumme at kende.',
  'trial.upgrade': 'Opgradér',
  'home.greeting': 'Hej igen 👋',
  'home.registerSale': 'Registrér salg',
  'home.registerSaleHelp': 'Registrér et nyt salg, eller opret en faktura til en kunde. Salget bogføres automatisk på den rigtige konto.',
  'home.registerPurchase': 'Registrér køb',
  'home.registerPurchaseHelp': 'Registrér et køb, eller upload et bilag. SuperPlumma foreslår konto og momsbehandling for dig.',
  'home.aiHelp': 'Her ser du alt, hvad SuperPlumma og hans agenter har gjort automatisk – bogføring, moms, løn og mere. Du godkender med ét tryk.',
  'home.autopilot.active': 'Aktiv',
  'home.autopilot.followUp': 'Skal følges op',
  'home.autopilot.disabled': 'Deaktiveret',
  'home.view.period': 'Periode',
  'home.view.analysis': 'Analyse',
  'home.view.cashflow': 'Nettoresultat',
  'home.viewLabel.period': 'Indtægter og omkostninger pr. måned',
  'home.viewLabel.analysis': 'Fordeling indtægter vs. omkostninger',
  'home.viewLabel.cashflow': 'Nettoresultat pr. måned',
  'home.ana.ring': 'Fordeling',
  'home.ana.gauge1': 'Nøgletal',
  'home.ana.gauge2': 'Finansielle nøgletal',
  'home.sub.yoyArrow': 'Pilen viser ændringen fra sidste år.',
  'home.sub.exVat': 'Alle summer vises ekskl. moms.',
  'home.legend.in': 'Ind',
  'home.legend.out': 'Ud',
  'home.legend.income': 'Indtægter',
  'home.legend.cost': 'Omkostninger',
  'home.legend.result': 'Resultat',
  'home.legend.cashflow': 'Resultat',
  'home.selectedMonths': 'Valgte måneder:',
  'home.reset': 'Nulstil',
  'home.sumOfMonth': 'Sum af {n} måned',
  'home.sumOfMonths': 'Sum af {n} måneder',
  'home.noPrevPeriod': 'Ingen forrige periode',
  'home.fromPrevMonth': 'fra forrige måned',
  'home.fromLastYear': 'fra sidste år',
  'home.showDistribution': 'Vis fordeling',
  'home.noData': 'Ingen data',
  'home.donut.registeredIncome': 'Registreret indtægt',
  'home.donut.registeredCosts': 'Registrerede omkostninger',
  'home.donut.income': 'Indtægter',
  'home.donut.costs': 'Omkostninger',
  'home.donut.result': 'Resultat',
  'home.donut.breakdown': '{title} — fordeling',
  'home.donut.back': 'Tilbage',
  'home.donut.hint': 'Tryk på en del af ringen eller et KPI-kort nedenfor for at se fordelingen',
  'home.health.good': 'God',
  'home.health.balanced': 'Balanceret',
  'home.health.weak': 'Svag',
  'home.gauge.explain': 'Forklar nøgletallet',
  'home.gauge.currentValue': 'Nuværende værdi',
  'home.gauge.assessment': 'Vurdering',
  'home.gauge.goodLevel': 'Godt niveau: {good}',
  'home.gauge.income': 'Indtægter',
  'home.gauge.income.info': 'Indtægter er summen af alt, hvad virksomheden har solgt i perioden, uden moms. Stigende indtægter over tid giver større handlefrihed.',
  'home.gauge.income.good': 'Stigende over tid',
  'home.gauge.costs': 'Omkostninger',
  'home.gauge.costs.info': 'Omkostninger er de udgifter, der skal til for at drive virksomheden, uden moms. Lavere omkostninger i forhold til indtægterne giver et bedre resultat.',
  'home.gauge.costs.good': 'Lavere end indtægterne',
  'home.gauge.result': 'Resultat',
  'home.gauge.result.info': 'Resultatet er det, der er tilbage, når omkostningerne trækkes fra indtægterne. Et positivt resultat betyder overskud i perioden.',
  'home.gauge.result.good': 'Positivt og stabilt',
  'home.gauge.liquidity': 'Likviditet',
  'home.gauge.liquidity.info': 'Likviditet viser evnen til at betale regninger og kortfristet gæld, når de forfalder. En højere værdi giver en bedre buffer.',
  'home.gauge.liquidity.good': 'Over 1,0x, helst over 2,0x',
  'home.gauge.profitability': 'Rentabilitet',
  'home.gauge.profitability.info': 'Rentabilitet viser, hvor stor en andel af indtægterne der bliver tilbage som resultat. Jo højere procent, jo mere tjener virksomheden pr. solgt krone.',
  'home.gauge.profitability.good': 'Positiv og stigende',
  'home.gauge.solidity': 'Soliditet',
  'home.gauge.solidity.info': 'Soliditet viser, hvor stor en del af virksomheden der er finansieret med egenkapital. Højere soliditet gør virksomheden mere robust.',
  'home.gauge.solidity.good': 'Højere egenkapitalandel over tid',
  'home.assistant.sub': 'Regnskabsassistent',
  'home.assistant.intro': 'Hej! Jeg kan udføre enkle handlinger for dig, oprette fakturaer, registrere køb, forklare skatter og afgifter og bogføre bilag fra indbakken. Spørg løs. Ønsker du økonomisk rådgivning, er rådgiveren tilgængelig på siden AI Rådgiver.',
  'home.assistant.thinking': 'SuperPlumma tænker...',
  'home.assistant.placeholder': 'Spørg SuperPlumma...',
  'home.assistant.noReply': 'SuperPlumma fik intet svar fra backend.',
  'home.assistant.errorReply': 'Kunne ikke hente svar fra assistenten lige nu.',
  'home.assistant.errorToast': 'Kunne ikke hente assistentsvar.',
  'home.assistant.cancel': 'Annuller',
  'home.assistant.opened': 'Jeg åbnede den rigtige side med forslaget klar til kontrol.',
  'home.assistant.openedToast': 'Åbnede det rigtige flow',
  'home.assistant.noAdapter': 'Denne handling har endnu ikke en Plumme-adapter.',
  'home.assistant.paymentNotConnected': 'Betalingsregistrering er ikke forbundet til backend.',
  'home.assistant.paymentRegistered': 'Betaling på {sum} er registreret på faktura{number}.',
  'home.assistant.paymentToast': 'Betaling registreret',
  'home.assistant.paymentFailed': 'Kunne ikke registrere betalingen.',
  'home.assistant.cancelled': 'Okay, jeg foretog ingen ændring.',
  'home.assistant.sugg1': 'Hvor meget skylder jeg i skatter og afgifter?',
  'home.assistant.sugg2': 'Opret en faktura til en kunde',
  'home.assistant.sugg3': 'Hvad er moms?',
  'home.action.register_payment': 'Godkend betaling',
  'home.action.create_invoice': 'Åbn fakturaudkast',
  'home.action.create_other_sale': 'Åbn andet salg',
  'home.action.create_expense': 'Åbn nyt køb',
  'home.action.register_purchase': 'Åbn nyt køb',
  'home.action.create_customer': 'Gem kunde',
  'home.action.create_supplier': 'Gem leverandør',
  'home.action.create_product': 'Gem produkt',
  'home.action.suggest_accounting_entry': 'Åbn fri postering',
  'home.action.create_mileage_entry': 'Åbn kørebog',
  'home.action.send_sales_document': 'Åbn fakturaliste',
  'home.action.book_bank_lines': 'Åbn bank',
  'home.action.link_bank_receipts': 'Åbn bank',
  'home.action.annul_bank_posting': 'Åbn bank',
  'home.action.reporting_preparation': 'Åbn indberetninger',
  'home.action.default': 'Åbn flow',
  'home.followup.title': 'Opfølgning',
  'home.followup.allClear': 'Alt er under kontrol',
  'home.followup.allClearSub': 'Intet at følge op på lige nu. Plumme siger til, når noget kræver opmærksomhed.',
  'home.followup.next': 'Gå videre',
  'home.followup.showMore': 'Vis mere',
  'home.followup.modalTitle': 'Opgaver, der skal løses',
  'home.followup.sales': 'Salg',
  'home.followup.purchases': 'Køb',
  'home.followup.toInvoiceList': 'Gå til fakturaliste',
  'home.followup.toVoucherList': 'Gå til bilagsliste',
  'home.followup.draftInvoices': 'Du har {n} fakturaudkast, der ikke er færdiggjort.',
  'home.followup.unsentInvoices': 'Du har {n} fakturaer, der er klar, men ikke sendt.',
  'home.followup.overdueInvoices': 'Du har {n} ubetalte forfaldne fakturaer.',
  'home.followup.openPurchases': 'Du har {n} ubetalte leverandørfakturaer.',
  'home.followup.missingAttachments': 'Du har {n} køb uden bilag.',
  'home.followup.bank': 'Bankafstemning',
  'home.followup.toBank': 'Gå til bankafstemning',
  'home.followup.missingBankStatements': 'Driftskontoen mangler kontoudtog for {months}',
  'home.overview.sales': 'Salg',
  'home.overview.purchases': 'Køb',
  'home.overview.outstandingSales': 'Udestående salg',
  'home.overview.outstandingPurchases': 'Udestående køb',
  'home.overview.salesHelp': 'Udestående salg er fakturaer, som dine kunder endnu ikke har betalt. Grøn er inden for forfald, gul er forfaldet — følg op på de forfaldne med en rykker.',
  'home.overview.purchasesHelp': 'Udestående køb er leverandørfakturaer, som du endnu ikke har betalt. Grøn er inden for forfald, gul er forfaldet og bør betales snart.',
  'home.overview.importedSubledger': 'Heraf importeret debitor-/kreditorsaldo: {amount}',
  'home.overview.inclVat': 'Beløbene er inkl. moms.',
  'home.overview.helpTitle': 'Udestående {what}',
  'home.overview.withinDue': 'Inden for fristen',
  'home.overview.overdue': 'Forfaldet',
  'home.overview.statusTitle': '{within} % inden for fristen · {over} % forfaldet',
  'home.deadlines.title': 'Kommende frister',
  'home.deadlines.help': 'Kommende indberetningsfrister - MVA-melding, skattemelding, årsregnskab og aksjonærregisteroppgave, med status for hver.',
  'home.deadlines.none': 'Ingen frister fundet i backend-data.',
  'home.deadlines.seeStatus': 'Se status',
  'home.deadlines.helpTax': 'Skattemeldingen samler regnskab og skatteberegning for året. Plumme hjælper dig med at kontrollere tallene før indsendelse.',
  'home.deadlines.helpAnnualAccounts': 'Årsregnskabet samler resultatopgørelse, balance og noter for regnskabsåret og sendes til Regnskapsregisteret, når det er klar.',
  'home.deadlines.helpAnnualClosing': 'Årsafslutningen lukker regnskabsåret med kontroller, disponering og nødvendige afslutningsposteringer.',
  'home.deadlines.helpShareholderRegister': 'Aksjonærregisteroppgaven (RF-1086) indsendes af aktieselskaber senest 31. januar året efter indkomståret. Plumme har ingen indsendelse for den — dette er en påmindelse.',
  'home.deadlines.helpVat': 'MVA-meldingen indberetter udgående og indgående moms for perioden.',
  'home.deadlines.helpFallback': 'Frist for {name}. Plumme giver besked og hjælper dig videre fra statusvisningen.',
  'home.deadlines.fallbackName': 'indsendelse',
  'home.deadlines.name.shareholderRegister': 'Aksjonærregisteroppgaven',
  'home.fees.title': 'Offentlige afgifter',
  'home.fees.help': 'Oversigt over, hvad du skylder det offentlige lige nu - moms, skattetræk og arbejdsgiverafgift. Beregnes løbende ud fra bogføringen.',
  'home.fees.none': 'Ingen åbne offentlige afgifter fundet.',
  'home.balances.title': 'Saldo',
  'home.balances.help': 'Bogført saldo på bank-, kontant- og andre konti. Tallene kommer fra saldobalancen, så de viser, hvad regnskabet siger - ikke hvad banken har nået at opdatere. Med tandhjulet vælger du, hvilke konti der vises, og kan søge flere frem i kontoplanen. Driftskontoen og kassen kan skjules, men ikke fjernes.',
  'home.balances.choose': 'Vælg konti',
  'home.balances.total': 'I alt',
  'home.balances.accountFallback': 'Konto {code}',
  'home.balances.noneSelected': 'Ingen konti valgt.',
  'home.balances.searchPlaceholder': 'Søg i kontoplanen …',
  'home.balances.noHits': 'Ingen resultater',
  'home.balances.remove': 'Fjern fra kortet',
  'home.balances.saveFailed': 'Kunne ikke gemme kontovalget.',
  'set.account': 'Konto',
  'set.amount': 'Beløb',
  'set.page': 'Side',
  'set.debit': 'Debet',
  'set.credit': 'Kredit',
  'set.remove': 'Fjern',
  'set.ib.title': 'Åbningsbalance',
  'set.ib.startWizard': 'Start guiden for at oprette åbningsbalance',
  'set.ib.confirmDate': 'Bekræft startdatoen',
  'set.ib.setUp': 'Opsæt åbningsbalance',
  'set.ib.confirmDateInPlumme': 'Bekræft startdatoen i Plumme',
  'set.ib.startDate': 'Startdato',
  'set.back': 'Tilbage',
  'set.ib.dateOk': 'Datoen stemmer, gå videre',
  'set.ib.draftEmpty': 'Kladden er tom.',
  'set.text': 'Tekst',
  'set.toDebit': 'Til (debet)',
  'set.fromCredit': 'Fra (kredit)',
  'set.editLine': 'Redigér linje',
  'set.removeLine': 'Fjern linje',
  'set.quickPick': 'Hurtigvalg',
  'set.addNewLine': 'Tilføj ny linje',
  'set.saved': 'Gemt',
  'set.startOver': 'Start forfra',
  'set.ib.finish': 'Færdiggør åbningsbalance',
  'set.ib.summary': 'Oversigt - beløb ind og ud af konti',
  'set.ib.openNote': 'Posteringen er åben og kan ændres fra denne visning.',
  'set.ib.intoAccount': 'Ind på konto',
  'set.ib.outOfAccount': 'Ud fra konto',
  'set.sum': 'Sum',
  'set.ib.openEntry': 'Åben postering',
  'set.accountNo': 'Kontonr.',
  'set.name': 'Navn',
  'set.vatCode': 'Momskode',
  'set.description': 'Beskrivelse',
  'set.relevantLinks': 'Relevante links',
  'set.deleteCancel': 'Slet / annuller',
  'set.ib.edit': 'Ændr åbningsbalance',
  'set.ib.openingForAccount': 'Primosaldo for konto',
  'set.cancel': 'Annuller',
  'set.save': 'Gem',
  'set.ib.postDescription': 'Beskrivelse af posten',
  'set.pickAccount': 'Vælg konto ...',
  'set.accountDebit': 'Konto (debet)',
  'set.ib.cannotBeEmpty': 'Kan ikke oprette tom åbningsbalance',
  'set.continueTitle': 'Fortsæt?',
  'set.ib.post': 'Bogfør åbningsbalance',
  'set.ib.draftTitle': 'Kladde til åbningsbalance',
  'set.ib.draftHelp': 'Indtast balancetal fra dit tidligere system, så saldobalancen starter korrekt i Plumme.',
  'set.noteOptional': 'Notat (valgfrit)',
  'set.notePh': 'For eksempel hvad der blev importeret og fra hvilken dato',
  'set.ib.lines': 'Balancelinjer',
  'set.ib.linesHelp': 'Balancetallene på overgangsdatoen, fordelt på konto: aktiver, egenkapital og gæld fra det gamle system. Før én linje pr. konto, så balancen starter med de rigtige tal i Plumme.',
  'set.ib.addLine': 'Tilføj balancelinje',
  'set.startup.title': 'Starttal',
  'set.startup.introText': 'Brug dette, hvis du flytter til Plumme midt i {year}. Du fører moms og resultattal fra dit tidligere system, så rapporterne og skattemeldingen fortsætter korrekt fra overgangsdatoen.',
  'set.startup.startWizard': 'Start guiden for at indtaste starttal',
  'set.startup.stepDate': 'Overgangsdato og moms',
  'set.startup.stepLines': 'Salg og omkostninger',
  'set.startup.confirmTitle': 'Bekræft overgangsdato og moms indtil nu',
  'set.startup.linesTitle': 'Fordel tallene før {date}',
  'set.startup.save': 'Gem starttal',
  'set.startup.receiptTitle': 'Starttal pr. {date}',
  'set.startup.receiptSub': 'Gemt til overgangen til Plumme',
  'set.startup.receiptLines': '{lines} linjer registreret - {sales} salg og {costs} omkostning.',
  'set.startup.edit': 'Ændr starttal',
  'set.transitionDate': 'Overgangsdato',
  'set.transitionDateHelp': 'Datoen, hvor du gik over til Plumme. Starttallene gælder perioden fra årets start frem til denne dato, ført i det gamle system.',
  'set.outputVatBefore': 'Udgående moms før start',
  'set.outputVatBeforeHelp': 'Moms, du allerede har opkrævet på salg indtil nu i år, før overgangen. Lægges til årets momstal, så MVA-meldingen bliver korrekt.',
  'set.inputVatBefore': 'Indgående moms før start',
  'set.inputVatBeforeHelp': 'Moms, du allerede har betalt på køb indtil nu i år (og har fradrag for), før overgangen.',
  'set.salesByAccount': 'Salg fordelt på konto',
  'set.salesByAccountHelp': 'Salgsindtægterne indtil nu i år, fordelt på indtægtskonto. Før én linje pr. salgskonto, så resultatopgørelsen starter med de rigtige tal.',
  'set.salesByAccountBefore': 'Salg fordelt på konto før start',
  'set.addSalesLine': 'Tilføj salgslinje',
  'set.noSalesLines': 'Ingen salgslinjer endnu.',
  'set.costsByAccount': 'Omkostninger fordelt på konto',
  'set.costsByAccountHelp': 'Omkostningerne indtil nu i år, fordelt på omkostningskonto. Før én linje pr. omkostningskonto, så resultatet bliver korrekt fra overgangsdatoen.',
  'set.costsByAccountBefore': 'Omkostninger fordelt på konto før start',
  'set.addCostLine': 'Tilføj omkostningslinje',
  'set.noCostLines': 'Ingen omkostningslinjer endnu.',
  'set.import.title': 'Importér komplet regnskab',
  'set.import.pickPackage': 'Vælg eksportfiler',
  'set.import.shouldContain': 'Pakken bør indeholde',
  'set.import.saft': 'SAF-T Financial XML',
  'set.import.parties': 'Kunde- og leverandørregister, gerne Excel eller CSV',
  'set.import.chart': 'Kontoplan',
  'set.import.vouchers': 'Bilag, kvitteringer og fakturaer som PDF eller billeder',
  'set.import.bankRecs': 'Bankafstemninger og fakturakopier',
  'set.import.firstStep': 'Første trin i Plumme',
  'set.import.readsStructure': 'Læser filstrukturen',
  'set.import.findsFiles': 'Finder SAF-T, Excel og bilagsfiler',
  'set.import.buildsAnalysis': 'Laver en importanalyse',
  'set.import.letsApprove': 'Lader dig godkende sikker import af kontoplan, kunder, leverandører og åbningsbalance',
  'set.import.notAutomatic': 'Ikke automatisk endnu',
  'set.import.noPromise': 'Plumme lover ikke, at alt bliver nøjagtigt identisk med dit tidligere system',
  'set.import.noHistoric': 'Historiske posteringer bogføres ikke uden godkendelse',
  'set.import.nothingToAltinn': 'Intet sendes til Altinn',
  'set.import.noOverwrite': 'Eksisterende bilag slettes eller overskrives ikke uden bekræftelse',
  'set.close': 'Luk',
  'set.import.approveBase': 'Godkend import af grunddata',
  'set.import.working': 'Arbejder...',
  'set.import.uploading': 'Upload til Firebase Storage',
  'set.import.serverReading': 'Serveren læser importfilerne nu',
  'set.import.importingBase': 'Importerer grunddata',
  'set.import.savedInAccounts': 'Importen er gemt i regnskabet',
  'set.import.checkBefore': 'Kontrollér kontoplan, kunder, leverandører og åbningsbalance før rapportering.',
  'set.import.dataOnlyTitle': 'Importér kun regnskabsdata (anbefales)',
  'set.import.dataOnlyHelp': 'Plumme laver en filtreret kopi i browseren med SAF-T, CSV og Excel. PDF\'er, billeder og andre dokumenter uploades ikke.',
  'set.import.dataOnlyKeepOriginal': 'Behold den originale ZIP-fil fra Fiken.',
  'set.import.dataOnlyFiltering': 'Fjerner dokumenter før upload',
  'set.import.dataOnlyFilteringHelp': 'Originalfilen ændres ikke. Kun den nye, filtrerede datapakke sendes til Plumme.',
  'set.import.dataOnlyFiltered': '{count} dokument- og bilagsfiler blev udeladt fra uploadet.',
  'set.import.dataOnlyLibraryFailed': 'Kunne ikke indlæse ZIP-filteret. Prøv igen, eller udpak SAF-T, CSV og Excel manuelt.',
  'set.import.dataOnlyNoFiles': 'Fandt ingen SAF-T-, CSV- eller Excel-filer i ZIP-pakken.',
  'set.import.packages.title': 'Gemte importpakker',
  'set.import.packages.help': 'Her ser du alle ZIP-filer, og hvilken pakke der er aktiv kilde for importarkivet.',
  'set.import.packages.loading': 'Indlæser pakker...',
  'set.import.packages.empty': 'Ingen gemte ZIP-filer.',
  'set.import.packages.statusImported': 'Aktiv import',
  'set.import.packages.statusDuplicate': 'Identisk dublet',
  'set.import.packages.statusPrevious': 'Tidligere import',
  'set.import.packages.statusAnalyzed': 'Aflæst',
  'set.import.packages.statusFailed': 'Aflæsning mislykkedes',
  'set.import.packages.statusAnalyzing': 'Aflæses',
});
